/**
 * Created by DSadler on 02/05/2017.
 */
import * as actions from './actions';
import init from './initialState.json';

let initialState = init;

export function images (state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_IMAGE:
      return state;
    case actions.UPDATE_IMAGE:
      return state;
    case actions.DELETE_IMAGE:
      return state;
    case actions.SET_IMAGES:
      return state;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/state/images/reducers.js